import type { Signal } from '@angular/core';
import { ChangeDetectionStrategy, Component, computed, input, inject } from '@angular/core';
import type { FormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { I18nService, TranslatePipe } from '@core/i18n-legacy';
import { NameSymbolInputComponent } from '@core/symbol-legacy';
import type { IconName } from '@core/user-interface-legacy';
import type { AnyViewSymbol, ViewLayout } from '@core/views-types';

@Component({
  selector: 'rt-views-view-name-input',
  imports: [ReactiveFormsModule, TranslatePipe, NameSymbolInputComponent],
  templateUrl: './view-name-input.component.html',
  styleUrls: ['./view-name-input.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewNameInputComponent {
  private readonly i18n = inject(I18nService);

  public nameControl = input.required<FormControl<string>>();
  public symbolControl = input.required<FormControl<AnyViewSymbol | null>>();
  public isViewPredefined = input<boolean>(false);
  public layoutType = input.required<ViewLayout['type']>();
  public disabled = input<boolean>(false);

  public fallbackIcon: Signal<IconName> = computed(() => {
    const symbolValue = this.symbolControl().value;
    if (this.isViewPredefined() && symbolValue?.type === 'icon') {
      return <IconName>symbolValue.name;
    }

    return 'insert-emoticon';
  });
  public errors = {
    required: this.i18n.translate('app.views.view_settings.view_name_required_error'),
  };
}
